<template>
  <v-container
    class="align-content-start pa-0"
    fill-height
    fluid
  >
    <v-row>
      <v-col
        v-if="Loans.DescriptiveStatistics"
        cols="12"
        lg="4"
        md="4"
      >
        <descriptive-statistics :risk-analysis-id="accountId" />
      </v-col>

      <v-col
        v-if="Loans.LoansMaturity"
        cols="12"
        lg="8"
        md="8"
      >
        <loans-maturity :risk-analysis-id="accountId" />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-if="Loans.InterestIncome"
        cols="12"
        md="4"
      >
        <net-interest-income />
      </v-col>
      <v-col
        v-if="Loans.TypeAllocation"
        cols="12"
        md="8"
      >
        <loan-type-allocation />
      </v-col>
    </v-row>

    <!-- Dynamic Evolution Row -->
    <v-row>
      <v-col
        v-if="Loans.DynamicEvolution"
        cols="12"
      >
        <dynamic-evolution :risk-analysis-id="accountId" />
      </v-col>
    </v-row>

    <!-- Loan Concentration Row -->
    <v-row>
      <v-col
        v-if="Loans.LoansConcentration"
        cols="12"
        lg="8"
        md="6"
      >
        <loan-concentration :risk-analysis-id="accountId" />
      </v-col>
      <v-col
        v-if="Loans.FixedFloatingComparison"
        cols="12"
        lg="4"
        md="6"
      >
        <fixed-vs-floating-rates :risk-analysis-id="accountId" />
      </v-col>
    </v-row>
  </v-container>
</template>

  <script>
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import API                               from '@/api/Api'
import { clone }                         from '@/lib/utils/helper'
import ALMLoansResource from '@/api/resources/alm/ALMLoansResource'
import DescriptiveStatistics from '@/theme/default/views/banking/alm/loans/blocks/DescriptiveStatistics.vue'
import AssetModel from '@/api/models/asset/AssetModel'
import LoansMaturity from '@/theme/default/views/banking/alm/loans/blocks/LoansMaturity.vue'
import DynamicEvolution from '@/theme/default/views/banking/alm/loans/blocks/DynamicEvolution.vue'
import LoanConcentration from '@/theme/default/views/banking/alm/loans/blocks/LoanConcentration.vue'
import FixedVsFloatingRates from '@/theme/default/views/banking/alm/loans/blocks/FixedVsFloatingRates.vue'
import LoanTypeAllocation from '@/theme/default/views/banking/alm/loans/blocks/LoanTypeAllocation.vue'
import NetInterestIncome from '@/theme/default/views/banking/alm/loans/blocks/NetInterestIncome.vue'

export default {
  name      : 'ALMLoansPortfolio',
  components: {
    DescriptiveStatistics,
    LoansMaturity,
    DynamicEvolution,
    LoanConcentration,
    FixedVsFloatingRates,
    LoanTypeAllocation,
    NetInterestIncome
  },
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : {
    selectedDate: {
      type   : String,
      default: ''
    }
  },
  dataStore: {
    appToolbarExtended: 'App.Config.AppToolbarExtended',

    Loans: 'ALM.Loans.Data',

    riskBaseCurrencyData: 'Risks.BaseCurrency.Data'
  },
  enums: {},
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364
    }
  },
  computed: {
    breadcrumb () {
      return [{
        text    : this.$t('ALM.HeaderTitle'),
        disabled: true
      }]
    },
    accountId () {
      return this.user?.selectedAccountId || null
    }
  },
  watch: {
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    },
    selectedDate: {
      handler (newDate) {
        if (newDate && newDate.trim() !== '') {
          this.getData()
        }
      },
      immediate: true
    }
  },
  created () {
    if (this.selectedDate && this.selectedDate.trim() !== '') {
      this.getData()
    }
  },
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  destroyed () {},
  methods: {
    getData () {
      const params = this.selectedDate ? [this.accountId, this.selectedDate] : [this.accountId]
      API.Resource.ALM.GetALMLoans(...params)
        .then(response => {
          this.handleResponse(response)
        })
        .catch(e => {
          this.handleResponse(e.response)
        })
        .finally(() => {})
    },
    handleResponse (response) {
      const data = API.responseData(response)?.findALMInfo || null

      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        const o = clone(data)
        this.Loans = new ALMLoansResource(o)

        this.$set(this.riskBaseCurrencyData, this.accountId, new AssetModel(o.baseCurrency ?? null))
      } else {
        this.Loans = null
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
  </script>

  <style scoped>

  </style>
